<style>
  .label{
    font-weight: 900;
  }
</style>
<template>
  <div class="col-8 mb-primary mx-auto" v-if="!redirected">
    <div class="card card-with-shadow border-0 h-100 justify-content-center">
      <div class="card-header p-primary bg-transparent d-flex justify-content-between align-items-center">
      <h5 class="card-title m-0 label">{{ $t('create_new_master_contract') }}</h5>
      <button type="submit" class="btn btn-danger" @click.prevent="clear">
        {{ $t('X') }}
      </button>
    </div>
      <app-overlay-loader v-if="preloader" />
      <div class="card-body mt-5 align-items-center justify-content-center ">
        <form ref="form" data-url="/crud" class="mb-0" :class="{ 'loading-opacity': preloader }" >
          <!-- select country to contract -->
          <div class="form-group row">
            <label class="col-sm-12 col-md-4 col-form-label text-left label"> {{ $t("country") }} </label>
            <app-input 
              class = "col-md-7 col-sm-12 mt-2 pt-1" 
              :placeholder = "$t('select_country_phd')" 
              type = "advance-search-select"
              fetch-url = "/countries/serverside/selectable-name"
              listValueField = "name"
              v-model = "inputs.country" 
              :loaded-per-time = "5" 
              :required = "true"  
              @change = "updateContractNumber"
              :disabled="isFromCost"
            />
          </div>

          <!-- select product categorie -->
          <div class="form-group row">
            <label class="col-sm-12 col-md-4 col-form-label text-left label"> {{ $t("category") }} </label>
            <app-input 
              class="col-md-7 mt-2 pt-1" 
              :placeholder="$t('select_category_phd')" 
              type="advance-search-select"
              fetch-url="/productCategories/serverside/selectable-name" 
              v-model="inputs.category" 
              listValueField="name"
              :loaded-per-time="5" :required="true"               
              @change="updateContractNumber"
              :disabled="isFromCost"
            />
          </div>

          <!-- automatic number generator  -->
          <div class="form-group row">
                <label for="contract_number" class="col-sm-12 col-md-4 col-form-label text-left label">
                  {{ $t("contract_number") }}
                </label>
                <div class="col-sm-7">
                  <app-input id="contract_number" type="text" v-model="inputs.contractNumber"
                    :placeholder="$t('contract_number_phd')" :disabled="true" />
                </div>
           </div>
           <app-input class="col-md-7 mt-2 pt-1" type="hidden" v-model="inputs.contract_number_r" />
           <!-- btn  -->

          <div class="mt-5 text-center">
            <button type="button" class="btn btn-primary mr-2" @click="redirectToContractDetail">
              {{ $t('create') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from '../../../../core/mixins/form/FormMixin.js';
import { ref, onMounted } from 'vue';

export default {
  name: "ContractAdd",
  props: {
    customTable: {
      type: [String, Object],
      default: () => null
    }
  },
  mixins: [FormMixin],
  data() {
    return {
      isFromCost : false,
      preloader: false,
      redirected: false,
      inputs: {
        country: {
          id: null,
          name: null,
          Code: null,
        },
        category: {
          id: null,
          name: null,
          code: null
        },
        contractNumber: '',
        contract_number_r: '',
      },
      initialContractNumber: 10000,
      errors: {},
    };
  },

  methods: {
    async getNum() {
      try {
        const response = await axios.get('/contracts/serverside/contract-number');
        this.inputs.contract_number_r = (response.data == '0') ? 0 : response.data;
        console.log(this.inputs.contract_number_r);
        
      } catch (error) {
        console.error('Error fetching contract number:', error);
      }
    },
    
    
    updateContractNumber(_) {
      if (this.inputs.country.Code) {
        localStorage.setItem('countrySelected', JSON.stringify(this.inputs.country));
      }
      if (this.inputs.category.code) {
        localStorage.setItem('categorySelected', JSON.stringify(this.inputs.category));
      }

      if (this.inputs.country.Code && this.inputs.category.code && this.inputs.contract_number_r !== '') {
        const formattedCountryCode = String(this.inputs.country.Code).padStart(2, '0');        
        const formattedCategoryCode = String(this.inputs.category.code).padStart(1, '0');
        const number = 1000 + (parseInt(this.inputs.contract_number_r) + 1);
        this.inputs.contractNumber = `${formattedCountryCode}${formattedCategoryCode}${number}`;
        localStorage.setItem('contractNumber', this.inputs.contractNumber);
      }
    },

    validateForm() {
      this.errors = {};
      let valid = true;
      if (!this.inputs.country.Code) {
        this.errors.country = 'Country is required';
        valid = false;
      }

      if (!this.inputs.category.code) {
        this.errors.category = 'Category is required';
        valid = false;
      }
      return valid;
    },

    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      if (this.validateForm) {
        this.redirectToContractDetail();
      }
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {
        selectCountry: '',
        selectCategory: '',
        smart_select: null,
      };
      this.multiSelect = [];
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    async clear() {
      localStorage.removeItem('countrySelected');
      localStorage.removeItem('categorySelected');
      localStorage.removeItem('contractNumber');
      localStorage.removeItem("DataContractDetail");
      localStorage.removeItem("DataContractMaster");
      localStorage.removeItem("DataProductDetail");
      localStorage.removeItem("DataSupplierDetail");
      localStorage.removeItem("DataCustomerDetail");
      localStorage.removeItem("categorySelected");
      localStorage.removeItem("contractNumber");
      localStorage.removeItem("countrySelected");
      localStorage.removeItem("selectedProducts");
			localStorage.removeItem("process_add_contract");
      localStorage.removeItem('is_from_cost');
      this.getNum();
      this.inputs = {
        country: { id: null, name: null, Code: null },
        category: { id: null, name: null, code: null},
        contractNumber: '',
        contract_number_r : '',
      };
    },

    // esta funcion redirecciona a la vista de los detalles
    redirectToContractDetail() {
      if (this.validateForm()) {
        localStorage.setItem('process_add_contract', true);
        this.redirected = true;
        this.$router.push({
          // name: 'contract'
          name: 'contract',
          query: { 'tab': 'contract' },
          params: { id: false }
        });
      }else{
        const values = Object.values(this.errors);
        for (const field of values) {
          this.$toastr.e(field);
        }
      }
    },
  },
  watch: {  
    'inputs.country.Code'(newVal) {
      this.updateContractNumber(newVal);
    },
    'inputs.category.code'(newVal) {
      this.updateContractNumber(newVal);
    },
    'inputs.contract_number'(newValue) {
      if (newValue) {
        console.log('Contract number received:', newValue);
      } else {
        console.error('Error: Contract number is empty or null');
      }
    },
    inputs : {
            deep : true,
            handler(newVal){
                localStorage.setItem('DataContractMaster', JSON.stringify(newVal));
            }
        }
  },
  async mounted() {
    await this.getNum();
    // manejo de la persistencia en country
    if (localStorage.getItem('countrySelected') !== 'undefined') {  
      const countrySelected = JSON.parse(localStorage.getItem('countrySelected'));
      if (countrySelected && typeof countrySelected === 'object' && countrySelected.Code !== undefined) {
        this.inputs.country = countrySelected;
        this.updateContractNumber();
      }
    }

    // manejo de la persistencia de category
    if (typeof localStorage.getItem('categorySelected') !== 'undefined') {
      const categorySelected = JSON.parse(localStorage.getItem('categorySelected'));
      if (categorySelected && typeof categorySelected === 'object' && categorySelected.code !== undefined) {
        this.inputs.category = categorySelected;
        this.updateContractNumber();
      }
    }

    // manejo de la persistencia del numero del contrato
    const contractNumberInput = localStorage.getItem('contractNumber');
    if (contractNumberInput && contractNumberInput != '') {
      this.inputs.contractNumber = contractNumberInput;
    }

    if (typeof localStorage.getItem('is_from_cost') !== 'undefined' && localStorage.getItem('is_from_cost')) {
      this.isFromCost = true;
    }
  },
}
</script>
